import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { GetEmployeeDetails } from "adminApi/LoanReportApi/LoanReportApi";
import Spinner from "Common/Globle/Spinner";
import EmployeeLoansFullView from "./Components/EmployeeLoansFullView";

const ViewEmployeeLoans = () => {
    const { id } = useParams();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!id) return;

        if (hasFetched.current) return;
        hasFetched.current = true;

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await GetEmployeeDetails(id);
                if (response?.data?.success || response?.data?.status === 200) {
                    setDetails(response.data.data);
                } else {
                    setDetails(null);
                }
            } catch (error) {
                console.error("Fetch Error:", error);
                setDetails(null);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    return (
        <PageBody
            card
            headerchildren={
                <HeadingOne>Loan Report</HeadingOne>
            }>
            {loading ?
                <Spinner isSpinner />
                :
                <EmployeeLoansFullView details={details} />
            }
        </PageBody>
    );
};

export default ViewEmployeeLoans;
